import { render, staticRenderFns } from "./7_otherQuestions.vue?vue&type=template&id=78d93bfe&scoped=true&"
import script from "./7_otherQuestions.vue?vue&type=script&lang=js&"
export * from "./7_otherQuestions.vue?vue&type=script&lang=js&"
import style0 from "./7_otherQuestions.vue?vue&type=style&index=0&id=78d93bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d93bfe",
  null
  
)

export default component.exports